import BooleanSwitch from './booleanSwitch';

export enum FieldType {
  TEXT = 'text',
  BOOLEAN_SWITCH = 'booleanSwitch',
  MULTIPLE_CHOICE = 'multiplechoice',
  SELECTIVE_CHOICE = 'selectiveChoice',
  SIGNATURE = 'signature',
  INFO = 'info',
  NUMBER = 'number',
  IMAGE = 'image',
  NDA = 'nda',
}

export const FieldTypeList = [
  FieldType.TEXT,
  FieldType.BOOLEAN_SWITCH,
  FieldType.MULTIPLE_CHOICE,
  FieldType.SELECTIVE_CHOICE,
  FieldType.SIGNATURE,
  FieldType.INFO,
  FieldType.NUMBER,
  FieldType.IMAGE,
  FieldType.NDA,
];

// List of form fields allowed to have a required falsy value (e.g required to respond no)
export const RequiredFalsyValueFieldList = [FieldType.BOOLEAN_SWITCH];

export const RulableFieldList = [FieldType.BOOLEAN_SWITCH];

export const PrefillableFieldList = [
  FieldType.MULTIPLE_CHOICE,
  FieldType.BOOLEAN_SWITCH,
  FieldType.SELECTIVE_CHOICE,
  FieldType.TEXT,
  FieldType.NUMBER,
  FieldType.SIGNATURE,
];

export const ChoosableFieldList = [FieldType.MULTIPLE_CHOICE, FieldType.SELECTIVE_CHOICE];

export { BooleanSwitch as FieldBooleanSwitch };

export const RichTextFieldTypes = [
  FieldType.MULTIPLE_CHOICE,
  FieldType.SELECTIVE_CHOICE,
  FieldType.TEXT,
  FieldType.NUMBER,
  FieldType.BOOLEAN_SWITCH,
];
